import httpClient from "./httpClient";
import { Dashboard } from "../types/dashboard";

const END_POINT = "/dashboards";

export const dashboard = {
	fetchList: async (): Promise<Dashboard[] | undefined> => {
		const response = await httpClient.get(END_POINT);
		return response.data as Dashboard[];
	},
	get: async (id: number): Promise<Dashboard | undefined> => {
		const response = await httpClient.get(`${END_POINT}/${id}`);
		return response.data as Dashboard;
	},
	update: async (dashboard: Dashboard): Promise<Dashboard | undefined> => {
		const { id } = dashboard;
		const response = await httpClient.put(`${END_POINT}/${id}`, dashboard);
		return response.data;
	},
	create: async (dashboard: Dashboard): Promise<Dashboard | undefined> => {
		const response = await httpClient.post(`${END_POINT}`, dashboard);
		return response.data;
	},
	remove: async (id: number): Promise<undefined> => {
		const response = await httpClient.delete(`${END_POINT}/${id}`);
		return response.data as undefined;
	}
};

const fetchAll = async (): Promise<Dashboard[] | undefined> => {
	const response = await httpClient.get(END_POINT);
	return response.data as Dashboard[];
};

const fetch = async (id: number): Promise<Dashboard | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}`);
	return response.data as Dashboard;
};

const update = async (dashboard: Dashboard): Promise<Dashboard | undefined> => {
	const { id } = dashboard;
	const response = await httpClient.put(`${END_POINT}/${id}`, dashboard);
	return response.data;
};

const create = async (dashboard: Dashboard): Promise<Dashboard | undefined> => {
	const response = await httpClient.post(`${END_POINT}`, dashboard);
	return response.data;
};

const remove = async (id: number): Promise<undefined> => {
	const response = await httpClient.delete(`${END_POINT}/${id}`);
	return response.data as undefined;
};

export { fetchAll, fetch, update, create, remove };
